import React from 'react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/hooks/useLanguage';
import { Globe } from 'lucide-react';

const LanguageSwitcher = ({ variant = 'default' }: { variant?: 'default' | 'dark' }) => {
  const { language, setLanguage } = useLanguage();

  const isDark = variant === 'dark';

  return (
    <div className={`flex items-center space-x-2 ${isDark ? 'text-white' : 'text-current'}`}>
      <Globe className="h-4 w-4 text-white" />
      <div className={`flex rounded overflow-hidden border border-white/30 bg-white/10`}>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setLanguage('de')}
          className={`px-3 py-1 text-xs rounded-none border-0 text-white hover:bg-white/20 ${
            language === 'de'
              ? 'bg-white/30' 
              : 'bg-transparent'
          }`}
        >
          DE
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setLanguage('en')}
          className={`px-3 py-1 text-xs rounded-none border-0 text-white hover:bg-white/20 ${
            language === 'en'
              ? 'bg-white/30'
              : 'bg-transparent'
          }`}
        >
          EN
        </Button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;